document.addEventListener("DOMContentLoaded", function() {
  const tagList = document.getElementById("blogTagsList");
  const toggleBtn = document.getElementById("blogTagsToggle");
  const textMore = toggleBtn.dataset.textMore;
  const textLess = toggleBtn.dataset.textLess;

  if (!tagList || !toggleBtn) return;

  const tags = Array.from(tagList.querySelectorAll(".blog__tag"));
  const tagHeight = tags[0]?.offsetHeight || 0;
  const gap = parseFloat(getComputedStyle(tagList).gap) || 0;

  // extra offset for mobile so button does not overlap list
  const buttonHeight = toggleBtn.offsetHeight || 0;
  const buttonMargin = 10; // optional spacing between list and button

  // Zeilenbegrenzung je nach Bildschirm
  const lineLimit = window.innerWidth >= 768 ? 1 : 2;

  // visible height calculation
  const visibleHeight = lineLimit * tagHeight + (lineLimit - 1) * gap;

  // Add button height only for mobile
  const totalVisibleHeight = window.innerWidth >= 768 ? visibleHeight : visibleHeight;

  if(tagList.scrollHeight > visibleHeight) {
    tagList.setAttribute("data-toggle", "true");
    toggleBtn.style.display = "inline-block";
    let expanded = false;

    toggleBtn.addEventListener("click", () => {
      expanded = !expanded;
      if (expanded) {
        tagList.style.maxHeight = "none";
        toggleBtn.textContent = textLess;
      } else {
        tagList.style.maxHeight = `${visibleHeight}px`;
        toggleBtn.textContent = textMore;
      }
    });

    // Set initial max height
    tagList.style.maxHeight = `${visibleHeight}px`;
    tagList.style.overflow = "hidden"; // ensure hidden beyond 2 lines
  }
});